import { useMemo } from 'react';

import {
  useGetConsumerPropertiesByCause,
  useShowCauseBackerInfo,
  useShowConsumerCommunicationStatus,
} from '@givebacks/api/backer';
import { arrayHasLength } from '@givebacks/utils/array';
import { Stack, Tabs } from 'ui';

import { Communications } from './Communications';
import classes from './OrgInfoContent.module.css';
import { SharedInfo } from './SharedInfo';

interface OrgInfoContentProps {
  causeId: string;
}
const OrgInfoContent = ({ causeId }: OrgInfoContentProps) => {
  const { data: communicationStatus, isLoading: isCommunicationStatusLoading } =
    useShowConsumerCommunicationStatus({ causeId });
  const { data: properties } = useGetConsumerPropertiesByCause({
    causeId,
  });
  const { data: causeBackerInfo, isLoading: isCauseBackerInfoLoading } =
    useShowCauseBackerInfo(causeId);

  const status = useMemo(() => {
    return communicationStatus?.communication_status;
  }, [communicationStatus]);

  const isSubscriptionClosed = useMemo(() => {
    return causeBackerInfo?.site_joins_enabled === false && status !== 'subscribed';
  }, [causeBackerInfo, status]);

  if (isCauseBackerInfoLoading || isCommunicationStatusLoading || isSubscriptionClosed) {
    return null;
  }

  if (arrayHasLength(properties)) {
    return (
      <Stack w="100%">
        <Tabs
          defaultValue={'communications'}
          classNames={{
            root: classes.OrgInfoTabs,
            list: classes.OrgInfoTabs__list,
            tab: classes.OrgInfoTabs__tab,
          }}
        >
          <Tabs.List>
            <Tabs.Tab value="communications">Communications</Tabs.Tab>
            <Tabs.Tab value="info">Shared Info</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="communications">
            <Communications causeId={causeId} status={status ?? ''} />
          </Tabs.Panel>

          <Tabs.Panel value="info">
            <SharedInfo properties={properties} causeId={causeId} />
          </Tabs.Panel>
        </Tabs>
      </Stack>
    );
  }

  return (
    <Stack w="100%">
      <Communications causeId={causeId} status={status ?? ''} />
    </Stack>
  );
};

export { OrgInfoContent };
